var module;
// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['i18next', 'i18next-chained-backend', 'i18next-browser-languagedetector', 'react-i18next'], (i18n, backend, browser_langdetector, react_i18n) => {
  var inited = false;
  var i18n_init = (backends, backendOptions, opt = {}, init_prop) => {
    // XXX dmitriiz: webpack fix
    if (i18n && i18n.default) i18n = i18n.default;
    if (browser_langdetector && browser_langdetector.default) browser_langdetector = browser_langdetector.default;
    if (backend && backend.default) backend = backend.default;
    if (inited) return i18n;
    var save_missings = opt.save_missings;
    var ns = ['translation', ...(opt.ns || [])];
    var resources = init_prop && init_prop.i18n_store || undefined;
    var init_process = i18n.use(browser_langdetector).use(backend).use(react_i18n.initReactI18next).init({
      whitelist: ['en', 'ru', 'es', 'tr', 'de', 'fr', 'ja', 'he', 'zh'],
      fallbackLng: 'en',
      preload: ['en', 'ru', 'es', 'tr', 'de', 'fr', 'ja', 'he', 'zh'],
      ns: ns,
      defaultNS: 'translation',
      debug: opt.debug,
      keySeparator: opt.key_separator !== undefined ? opt.key_separator : '.',
      nsSeparator: opt.ns_separator !== undefined ? opt.ns_separator : ':',
      interpolation: {
        escapeValue: false
      },
      backend: {
        backends,
        backendOptions
      },
      detection: {
        caches: [],
        lookupQuerystring: 'lang',
        order: ['querystring']
      },
      react: {
        useSuspense: false
      },
      resources,
      saveMissing: save_missings,
      saveMissingTo: save_missings ? 'all' : 'fallback',
      missingKeyHandler: (lngs, ns, key) => {
        var lng = lngs[0];
        if (save_missings && lng != 'en' && lng) {
          if (!window.i18nkeys) window.i18nkeys = {};
          window.i18nkeys[key] = true;
        }
      }
    });
    inited = true;
    i18n._init_process = init_process;
    return i18n;
  };
  return i18n_init;
});